export default "__VITE_ASSET__DoofgV6f__"